<template>
    <div class="bng-virtual-sport-game">
        <jackpots-bar v-if="jackpots && jackpots.length"/>
        <router-view />
    </div>
</template>
<script>
import Vue from 'vue';

import JackpotsBar from '../../../../common/jackpots/jackpots-bar/jackpots-bar.vue';

export default {
    name: 'virtual-sport-game',
    components: { JackpotsBar },
    computed: {
        player() {
            return Vue.state.player.get();
        },
        jackpots() {
            return (this.player && this.player.balance && this.player.activeJackpots) || [];
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/virtual-sports/virtual-sport-game/virtual-sport-game.vue